import axios from 'axios'
import store from '@/store/index.js'

axios.interceptors.request.use(
  (confing) => {

    if (store.state.token) {
      confing.headers.Authorization = `Bearer ${store.state.token}`;
    }
    setTimeout(() => {
      store.commit('Set_Loading', true);
     }, 50);
    
    return confing;
  },
  (error) => {
    setTimeout(() => {
      store.commit('Set_Loading', false)
     }, 50);
   
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
     //console.log('攔截回應');
   
     setTimeout(() => {
      store.commit('Set_Loading', false)
     }, 50);
      
  
    return response;
  },
  (error) => {
    setTimeout(() => {
      store.commit('Set_Loading', false)
     }, 50);
   
    return Promise.reject(error);
  }
);
export default axios;